import CampaignsList from "@/components/Apps/Campaigns/CampaignsList";
import CreatorCampaignsList from "@/components/Creators/Dashboard/CreatorCampaignsList";
import CreatorDashboard from "@/components/Creators/Dashboard/CreatorDashboard";
import { api } from "@cvx/_generated/api";
import { convexQuery } from "@convex-dev/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useAccount } from "@/state/useAccount";
import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

const dashboardSearchSchema = z.object({
  campaignId: z.string().optional(),
  create: z.coerce.boolean().optional(),
});

export const Route = createFileRoute("/_app/_auth/dashboard/_layout/")({
  component: Dashboard,
  validateSearch: dashboardSearchSchema,
});

export default function Dashboard() {
  const { creatorId, appId, contractId } = useAccount();
  const { data: user } = useQuery(convexQuery(api.app.getCurrentUser, {}));

  const { campaignId: companyDashboardCampaignId, create } = Route.useSearch();

  // If user is a creator with a selected contract, show the specific campaign dashboard
  if (creatorId && contractId) {
    return <CreatorDashboard user={user} showCreate={create} />;
  }

  // If user is a creator without a selected contract, show aggregated campaigns list
  if (creatorId && !appId) {
    return <CreatorCampaignsList />;
  }

  // If user is an app founder, show campaigns list
  if (appId) {
    return (
      <CampaignsList
        appId={appId}
        selectedCampaignId={companyDashboardCampaignId}
      />
    );
  }

  return null;
}
